export default __webpack_public_path__ + "static/media/Icon feather-calendar.a008e606.svg";